<script context="module">
    import { z } from "zod";
    export const name = "issue";
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
    import { stripTags } from "@reperio-news/core.components/includes/Helpers";
    type Data = z.infer<typeof Data>;
    import { getContext } from "svelte";
    import ImageView from "@reperio-news/core.components/ImageView.svelte";

    export let data: Data = {};
    const c: SvelteStore<number | null> = getContext("parentBlockColumnCount");
</script>

{#if data && data.content}
    <a
        class="entry co-{$c}"
        style="--parentColumns:{$c};"
        href={data.content.url}
        title={data.content.summary}
    >
        {#if data.content.poster}
            <div class="image">
                <ImageView
                    src={data.content.poster}
                    crop={data.content.poster.crop}
                    height={400}
                    animatedQuality={45}
                    fit="cover"
                />
            </div>
        {/if}

        <div class="title">{data.content.title}</div>
    </a>
{/if}

<style lang="scss">
    .co-1 {
        flex-grow: 0 !important;
        width: calc(100% - 20px);
        a.title {
            padding: 5px;
            text-align: left;
            -webkit-line-clamp: 10;
        }
    }

    .co-2 {
        width: calc(50% - 30px);
        .title {
            -webkit-line-clamp: 3;
        }
    }

    .co-3 {
        width: calc(33% - 30px);
        .title {
            -webkit-line-clamp: 2;
        }
    }

    .co-4 {
        width: calc(25% - 30px);
    }

    .entry {
        margin: 10px;
        display: block;
        width: calc(30% - 20px);
        min-width: 200px;

        .image {
            object-fit: contain;
            filter: grayscale(90%) brightness(80%);
        }

        .title {
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
        }
    }

    .entry:hover {
        .image {
            filter: grayscale(0%) brightness(100%);
            transition: all 0.5s ease;
        }
    }

    :global {
        .carousel-news {
            div.entry {
                overflow: hidden;

                min-width: calc(
                    var(--parent-width) / var(--parentColumns) - 20px
                ) !important;

                a {
                    -webkit-line-clamp: 2;
                }

                .summary {
                    -webkit-line-clamp: 2;
                }
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        .co-1 {
            width: calc(100% - 30px);
            max-width: 100%;

            .image {
                height: 420px;
            }
        }
    }

    @media only screen and (max-width: 650px) {
        .entry {
            .image {
                height: auto;
            }
        }

        .co-1 {
            width: calc(100% - 30px);
        }

        :global {
            .carousel-news {
                div.entry {
                    min-width: calc(var(--parent-width) - 21px) !important;
                }
            }
        }
    }

    @media only screen and (max-width: 500px) {
        .entry {
            .image {
                height: auto;
                width: 100%;
            }
        }
    }
</style>
